import { Component, Input } from '@angular/core';
import {
    AccountAddress,
    InvoiceDetail,
    PaymentProfileCardsResponse,
} from '@viewbid/ts-angular-client';
import { PickupSlot } from '../../../../model/pickup-slot';

@Component({
    selector: 'vb-invoice-confirmation',
    templateUrl: './invoice-confirmation.component.html',
    styleUrls: ['./invoice-confirmation.component.scss'],
})
export class InvoiceConfirmationComponent {
    @Input() isStepThreeComplete: boolean = false;
    @Input() isStepTwoComplete: boolean = false;
    @Input() invoiceDetails: InvoiceDetail | null = null;
    @Input() scheduleLater: boolean = false;
    @Input() selectedDeliveryMethod: string | null = null;
    @Input() selectedDate: Date = new Date();
    @Input() selectedSlot: PickupSlot | null = null;
    @Input() proxyName: string = '';
    @Input() proxyTelephone: string = '';
    @Input() selectedShippingAddress: AccountAddress | null = null;
    @Input() selectedPaymentCard: PaymentProfileCardsResponse | null = null;
    @Input() isPayOnPickup: boolean = false;

    readonly eventsPurchasesUrl: string =
        'https://events.viewbid.ca/Account/Invoice/Purchases';

    get isPickupBranch(): boolean {
        return (
            this.selectedDeliveryMethod === 'pickup' ||
            this.selectedDeliveryMethod === 'proxyPickup'
        );
    }

    get isPaidInFull(): boolean {
        return !!this.invoiceDetails?.invoice?.isPaidInFull;
    }

    /** "214 Sterling Rd, Unit 3, M6R 2B2" — the read-back shipping line. */
    get shipLine(): string {
        const address: AccountAddress | null = this.selectedShippingAddress;
        if (!address) return '';
        return [address.address1, address.address2, address.postalCode]
            .filter((part?: string) => !!part)
            .join(', ');
    }
}
